import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledFooter from './Footer.style.js';

const Footer = (_ref) => {
  let {
    links,
    mainLinks,
    homeLink,
    addressHeadline,
    addressLabel,
    socialHeadline,
    navigationHeadline
  } = _ref,
      props = _objectWithoutProperties(_ref, ["links", "mainLinks", "homeLink", "addressHeadline", "addressLabel", "socialHeadline", "navigationHeadline"]);

  return /*#__PURE__*/React$1.createElement(StyledFooter, props, /*#__PURE__*/React$1.createElement("div", {
    className: "footer__wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "footer__address"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "footer__subline",
    variant: "subline",
    transform: "uppercase"
  }, addressHeadline), /*#__PURE__*/React$1.createElement(Link$1, {
    href: {
      pathname: '/standard',
      query: {
        uri: 'kontakt'
      }
    },
    asPath: "/kontakt",
    icon: null,
    invertedHover: true
  }, addressLabel)), links && links.length > 0 && /*#__PURE__*/React$1.createElement("div", {
    className: "footer__social-media"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "footer__subline",
    variant: "subline",
    transform: "uppercase"
  }, socialHeadline), /*#__PURE__*/React$1.createElement("ul", null, links.map(link => link ? /*#__PURE__*/React$1.createElement("li", {
    key: link.socialService
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: link.isActive ? 'is-active' : ''
  }, link, {
    icon: null,
    invertedHover: true
  }), link.label)) : null))), mainLinks && mainLinks.length > 0 && /*#__PURE__*/React$1.createElement("div", {
    className: "footer__main-navigation"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "footer__subline",
    variant: "subline",
    transform: "uppercase"
  }, navigationHeadline), /*#__PURE__*/React$1.createElement("ul", null, mainLinks.map(link => link ? /*#__PURE__*/React$1.createElement("li", {
    key: link.label
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: link.isActive ? 'is-active' : ''
  }, link, {
    icon: null,
    invertedHover: true
  }), /*#__PURE__*/React$1.createElement("span", null, link.label))) : null))), /*#__PURE__*/React$1.createElement("div", {
    className: "footer__icon"
  }, /*#__PURE__*/React$1.createElement("svg", {
    width: "136",
    height: "142",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 142"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M109.65.071c.47.16.832.536.974 1.005l.036.144 1.42 7.11 3.58-6.24a1.52 1.52 0 012.713 1.365l-.073.145-3.3 5.88 6-2.6a1.534 1.534 0 011.295 2.777l-.135.063-8.09 3.5v68l1.043.058c2.342.115 6.14.222 9.983.31l7.744.152h2.94l-13.93 13.89h11.74l-1.5 2a201.79 201.79 0 01-19.591 21.69l-1.179 1.12a127.75 127.75 0 01-18.38 14.61c-.91.59-1.93 1.16-3 1.7-13.73 7-29.92 6.66-43.79 0a44.08 44.08 0 01-5.63-3.18 133 133 0 01-16.08-13.09A201.79 201.79 0 014.675 98.948L3.67 97.67l-1.5-2h11.76L0 81.74l2.94-.04 4.762-.088c4.9-.099 10.308-.238 13.22-.394l.808-.048v-68l-8.09-3.5a1.52 1.52 0 011.058-2.846l.152.056 6 2.6-3.37-5.88a1.52 1.52 0 012.561-1.634l.079.124 3.58 6.24 1.41-7.11a1.53 1.53 0 013.021.462l-.021.138-1.91 9.5 27.89 32.49h27.6l27.88-32.49-1.91-9.5a1.53 1.53 0 011.99-1.749zM67.75 79.47c-6.34 0-11.47 2.51-11.47 5.61 0 2.896 4.476 5.277 10.234 5.578l.327.015-.184 18.084A74.36 74.36 0 0134.19 99.4a1.1 1.1 0 00-1.65 1.19l.147.587c1.045 4.027 4.744 15.344 14.563 22.953a35.5 35.5 0 0020.37 7.27h.27a35.35 35.35 0 0020.71-7.55c10.08-8 13.57-19.93 14.38-23.26a1.1 1.1 0 00-.319-1.056l-.101-.084a1.1 1.1 0 00-1.23 0 74.48 74.48 0 01-32.675 9.317l.186-18.1c5.842-.26 10.389-2.659 10.389-5.577 0-3.09-5.14-5.62-11.48-5.62zm19.07 42.97a33.35 33.35 0 01-18.93 6.77.47.47 0 01-.27 0A33.5 33.5 0 0149 122.68c4.65-3.422 11.212-5.6 18.507-5.706l.563-.004a32.69 32.69 0 0118.75 5.47zm-43.17-16.66l12.62 3.65-6.16 7.29-6.46-10.94zm48.22 0l-6.46 10.94-6.16-7.29 12.62-3.65zm-48.29-38.6c-3.617 0-6.55 5.717-6.55 12.77s2.933 12.77 6.55 12.77 6.55-5.717 6.55-12.77-2.933-12.77-6.55-12.77zm47.04 0c-3.617 0-6.55 5.717-6.55 12.77s2.933 12.77 6.55 12.77 6.55-5.717 6.55-12.77-2.933-12.77-6.55-12.77z",
    fillRule: "nonzero"
  })))));
};

Footer.propTypes = {
  homeLink: PropTypes$1.shape(),
  mainLinks: PropTypes$1.arrayOf(PropTypes$1.shape()),
  links: PropTypes$1.arrayOf(PropTypes$1.shape()),
  addressHeadline: PropTypes$1.string.isRequired,
  addressLabel: PropTypes$1.string.isRequired,
  socialHeadline: PropTypes$1.string,
  navigationHeadline: PropTypes$1.string
};
Footer.defaultProps = {
  homeLink: null,
  mainLinks: null,
  links: null,
  socialHeadline: null,
  navigationHeadline: null
};

export default Footer;
